/**
 * RESPONSE staff portal — env detection, mirrored on both sides.
 *
 * The same shape as GTA's: admin/src/App.jsx's isGtaHost() tests the hostname
 * with a regex the server's services/gta/GtaLoginService.isGtaEnv() also tests
 * the request host with. The duplication is deliberate and GTA's comment says
 * why — at /login there is no session yet, so the hostname is the only signal
 * available to the client.
 *
 * The regex matches a `response` label at the start of the host or as a whole
 * dot-separated label, optionally suffixed by an environment:
 *   response.agenticed.com          ✓
 *   response-dev.agenticed.com      ✓
 *   staff.response.agenticed.com    ✓
 *   agenticed.com                   ✗   (platform is untouched)
 *   gta.agenticed.com               ✗
 *   myresponse.example.com          ✗   (a substring is not a label)
 *
 * The last case is why this is anchored on a label boundary rather than a bare
 * `includes('response')`: a host that merely CONTAINS the word must not swap the
 * platform's login out from under it.
 */
export const RESPONSE_HOST_PATTERN = /(^|\.)response(-[a-z0-9]+)?\./i;

export function isResponseHost(hostname: string): boolean {
    return RESPONSE_HOST_PATTERN.test(hostname);
}
